const env = import.meta.env.VITE_APP_ENV || 'development';

const USER_PREF_PREFIXES = ['favoriteOrgs:'];

export function getFavoriteOrgsKey(userEmail: string): string {
  return `favoriteOrgs:${env}:${userEmail}`;
}

export function loadFavoriteOrgs(userEmail: string): string[] {
  try {
    const stored = localStorage.getItem(getFavoriteOrgsKey(userEmail));
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveFavoriteOrgs(userEmail: string, favorites: string[]): void {
  try {
    localStorage.setItem(getFavoriteOrgsKey(userEmail), JSON.stringify(favorites));
  } catch {
    // ignore storage errors
  }
}

/**
 * Clears session-scoped browser storage while preserving
 * user-preference localStorage keys (e.g. favoriteOrgs scoped per user/env).
 */
export function clearSessionStorage(): void {
  const preserved: [string, string][] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && USER_PREF_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      preserved.push([key, localStorage.getItem(key)!]);
    }
  }

  localStorage.clear();
  sessionStorage.clear();

  for (const [key, value] of preserved) {
    localStorage.setItem(key, value);
  }
}
